module.exports = __webpack_public_path__ + "assets/img/portal_financing.d29528d9.png";